import axios from "../axios";
import { setAlert } from "actions/alert";
import { OUR_PROPERTIES } from "constants/api";
import { GET_OURPROPERTIES, LOADING_ON_OURPROPERTIES_SUBMIT, LOADING_OURPROPERTIES, LOAD_OURPROPERTIES, OURPROPERTIES_ERROR, OURPROPERTIES_UPDATED, REMOVE_ERRORS } from "actions/types";
import { setErrorsList } from "actions/errors";
import { logout } from "actions/auth";

export const updateOurProperties = (formData, history, _id) => async (dispatch) => {
    dispatch({ type: REMOVE_ERRORS });
    dispatch({ type: LOADING_ON_OURPROPERTIES_SUBMIT });

    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };
    try {
        const res = await axios.put(`${OUR_PROPERTIES.UPDATE_OUR_PROPERTIES().ENDPOINT}`, formData, config);
        if (res.data.status === true) {
            dispatch({
                type: OURPROPERTIES_UPDATED,
            });
            dispatch(
                setAlert("Our properties updated successfully", "success")
            );
            history("/dashboard/cms");
        } else {
            const errors = res.data.errors;
            if (errors) {
                dispatch({
                    type: OURPROPERTIES_ERROR,
                });
                dispatch(setAlert(res.data.message, "danger"));
                errors.forEach((error) => {
                    dispatch(setErrorsList(error.msg, error.param));
                });
            }
        }
        return res.data ? res.data : { status: false };
    } catch (err) {
        if (err.response) {
            if (err.response.data && err.response.data.tokenStatus === 0) {
                dispatch(logout());
            } else {
                dispatch({
                    type: OURPROPERTIES_ERROR,
                    payload: {
                        msg: err.response.statusText,
                        status: err.response.status,
                    },
                });
                dispatch(
                    setAlert(
                        err.response.data.message || err.response.statusText,
                        "danger"
                    )
                );
            }
        }
    }
}

export const getOurProperties = () => async (dispatch) => {
    dispatch({ type: REMOVE_ERRORS });
    dispatch({ type: LOADING_OURPROPERTIES });
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        const res = await axios.get(
            `${OUR_PROPERTIES.GET_OUR_PROPERTIES().ENDPOINT}`,
            config
        );
        // dispatch({ type: REMOVE_ALERT });

        await dispatch({
            type: GET_OURPROPERTIES,
            payload: res.data.response,
        });
        return res.data ? res.data.response : { status: false };
    } catch (err) {
        // console.log(err);
        if (err.response) {
            if (err.response.data && err.response.data.tokenStatus === 0) {
                dispatch(logout());
            } else {
                dispatch({
                    type: OURPROPERTIES_ERROR,
                    payload: {
                        msg: err.response.statusText,
                        status: err.response.status,
                    },
                });
                dispatch(
                    setAlert(
                        err.response.data.message || err.response.statusText,
                        "danger"
                    )
                );
            }
        }
    }
};
// reset errors
export const removeErrors = () => async (dispatch) => {
    dispatch({ type: REMOVE_ERRORS });
};

export const setErrors = (errors) => async (dispatch) => {
    if (errors) {
        dispatch({ type: OURPROPERTIES_ERROR });
        dispatch(setAlert("Please correct the following errors", "danger"));
        errors.forEach((error) => {
            dispatch(setErrorsList(error.msg, error.param));
        });
    }
};

export const loadingOurProperties = () => async (dispatch) => {
    await dispatch({ type: LOAD_OURPROPERTIES });
};